export default __webpack_public_path__ + "static/media/goal_posture.504d33b6.png";